/**
 * A strip above every page (sign-in, onboarding, dashboard, admin): the product is in beta and
 * payments run against Stripe's sandbox, so no real money moves. The website has the same notice;
 * this one is the app's, in the app's own warm "heads-up" tokens so it reads in light and dark.
 *
 * The second sentence is only true while the API holds a test-mode Stripe key. Change it when live
 * keys go in.
 *
 * Switched off, not deleted, when beta ends: set `VITE_BETA_BANNER=off` for the build. It is a
 * plain in-flow strip rather than a fixed one, so it never covers the console's sticky sidebar
 * or the sign-in panel; it scrolls away like any header.
 */
export function BetaBanner() {
  if (import.meta.env.VITE_BETA_BANNER === 'off') return null
  return (
    <div
      role="note"
      className="px-4 py-2 text-center text-small font-medium"
      style={{
        background: 'var(--warn-quiet)',
        color: 'var(--warn-text)',
        borderBottom: '1px solid var(--warn-line)',
      }}
    >
      <b className="font-bold">Beta:</b> RingOut is still in development, so some things will change.
      Payments are in test mode, so no real money is taken.
    </div>
  )
}
